import { combineReducers } from 'redux'
import form from './form'

const accountReducer = combineReducers({
  form
})

export default accountReducer
